import React from "react";
import {Form, Slider, Switch} from "antd";
import ITableOptions from "../../../../../model/interface/widget/option/ITableOptions";
import LocaleText from "../../../settings/dictionary/LocaleText";

interface IProps {
    options: ITableOptions
}

class TableWidgetEditor extends React.Component<IProps> {

    render() {
        return (
            <>
                <Form.Item name={'columnsNumber'} label={<LocaleText code={'configuration.widget.table.columns'} fallback={'Počet sloupců'}/>}>
                    <Slider min={2} max={30} tooltipVisible/>
                </Form.Item>
                <Form.Item name={'rowsNumber'} label={<LocaleText code={'configuration.widget.table.rows'} fallback={'Počet řádků'}/>}>
                    <Slider min={2} max={30} tooltipVisible/>
                </Form.Item>
                <Form.Item name={'padding'} label={<LocaleText code={'configuration.widget.table.padding'} fallback={'Odsazení'}/>}>
                    <Slider min={0} max={5}/>
                </Form.Item>
                <Form.Item name={'bordered'} label={<LocaleText code={'configuration.widget.table.bordered'} fallback={'ohraničený'}/>} valuePropName={'checked'} initialValue={true}>
                    <Switch/>
                </Form.Item>
            </>

        )
    }
}

export default TableWidgetEditor